export const attachTrackings = (service, event, params) => {
    switch (service) {
        case 'hotjar':
            return _attachHotjar(event)
        case 'ga':
            return _attachGoogleAnalytics(event, params)
    }
}

function _attachHotjar(event) {
    if (window.hj) window.hj('event', event)
}

function _attachGoogleAnalytics(event, params) {
    if (window.gtag) window.gtag('event', event, params)
}
